import {Options, SpecialKey, Sign} from './types';

const getWhitelistedKeys = (signed: boolean, {radix, groupSeparator}: Options): string[] => {
  const w = [...'0123456789', radix, groupSeparator, ...Object.values(SpecialKey)];
  if (signed) return [...w, ...Object.values(Sign)];
  return w;
}

export default getWhitelistedKeys;
